/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfigFromJSON, FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfigToJSON, } from './FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfig';
import { FxIdDomainSettingsCompanyBrandingConfigFirebaseOptionsFromJSON, FxIdDomainSettingsCompanyBrandingConfigFirebaseOptionsToJSON, } from './FxIdDomainSettingsCompanyBrandingConfigFirebaseOptions';
import { FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigFromJSON, FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigToJSON, } from './FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfig';
import { FxIdDomainSettingsCompanyBrandingConfigLogosFromJSON, FxIdDomainSettingsCompanyBrandingConfigLogosToJSON, } from './FxIdDomainSettingsCompanyBrandingConfigLogos';
/**
 * Check if a given object implements the FxIdDomainSettingsCompanyBrandingConfig interface.
 */
export function instanceOfFxIdDomainSettingsCompanyBrandingConfig(value) {
    if (!('CompanyName' in value) || value['CompanyName'] === undefined)
        return false;
    if (!('BrandName' in value) || value['BrandName'] === undefined)
        return false;
    if (!('Logos' in value) || value['Logos'] === undefined)
        return false;
    if (!('HeaderElementType' in value) || value['HeaderElementType'] === undefined)
        return false;
    if (!('Auth' in value) || value['Auth'] === undefined)
        return false;
    return true;
}
export function FxIdDomainSettingsCompanyBrandingConfigFromJSON(json) {
    return FxIdDomainSettingsCompanyBrandingConfigFromJSONTyped(json, false);
}
export function FxIdDomainSettingsCompanyBrandingConfigFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'CompanyName': json['CompanyName'],
        'BrandName': json['BrandName'],
        'Logos': FxIdDomainSettingsCompanyBrandingConfigLogosFromJSON(json['Logos']),
        'HeaderElementType': json['HeaderElementType'],
        'FirebaseOptions': json['FirebaseOptions'] == null ? undefined : FxIdDomainSettingsCompanyBrandingConfigFirebaseOptionsFromJSON(json['FirebaseOptions']),
        'ThemeType': json['ThemeType'] == null ? undefined : json['ThemeType'],
        'ExternalTosUrl': json['ExternalTosUrl'] == null ? undefined : json['ExternalTosUrl'],
        'ExternalPpUrl': json['ExternalPpUrl'] == null ? undefined : json['ExternalPpUrl'],
        'Auth': FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigFromJSON(json['Auth']),
        'Adapters': json['Adapters'] == null ? undefined : (json['Adapters'].map(FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfigFromJSON)),
    };
}
export function FxIdDomainSettingsCompanyBrandingConfigToJSON(json) {
    return FxIdDomainSettingsCompanyBrandingConfigToJSONTyped(json, false);
}
export function FxIdDomainSettingsCompanyBrandingConfigToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'CompanyName': value['CompanyName'],
        'BrandName': value['BrandName'],
        'Logos': FxIdDomainSettingsCompanyBrandingConfigLogosToJSON(value['Logos']),
        'HeaderElementType': value['HeaderElementType'],
        'FirebaseOptions': FxIdDomainSettingsCompanyBrandingConfigFirebaseOptionsToJSON(value['FirebaseOptions']),
        'ThemeType': value['ThemeType'],
        'ExternalTosUrl': value['ExternalTosUrl'],
        'ExternalPpUrl': value['ExternalPpUrl'],
        'Auth': FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigToJSON(value['Auth']),
        'Adapters': value['Adapters'] == null ? undefined : (value['Adapters'].map(FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfigToJSON)),
    };
}
//# sourceMappingURL=FxIdDomainSettingsCompanyBrandingConfig.js.map